export const platFormLevelMenu = [
  {
    name: "Platform Admins",
    listPer: "platform_admin",
    group: "platform_admins",
    navLink: "/platform-admin",
    faIconClass: "fas fa-user-cog me-3",
    matIconClass: null,
  },
  {
    name: "Agencies",
    listPer: "agency",
    group: "agency",
    navLink: "agency",
    faIconClass: null,
    matIconClass: "supervisor_account",
  },
  {
    name: "Advertisers",
    listPer: "advertiser",
    group: "advertiser",
    navLink: "/advertiser",
    faIconClass: "fas fa-users me-3",
    matIconClass: null,
  },
  {
    name: "Contract Uploads",
    listPer: "msa_contract",
    group: "contract",
    navLink: "/contract",
    faIconClass: "fas fa-file-signature me-3",
    matIconClass: null,
  },
  {
    name: "Platform Notifications",
    listPer: "notification",
    group: "notification",
    navLink: "/platform-notification",
    faIconClass: "fas fa-file-signature me-3",
    matIconClass: null,
  },
  {
    name: "Account Managers",
    listPer: "account_manager",
    group: "account-managers",
    navLink: "/account-manager",
    faIconClass: "fas fa-user-tie me-3",
    matIconClass: null,
  },
  {
    name: "Analytics",
    // viewPer: "basic_analytics", uncomment once we support analytics.
    viewPer: "xxx_basic_analytics_xxx",
    group: "analytics",
    navLink: "/analytics/standard-analytics",
    faIconClass: null,
    matIconClass: "pie_chart",
    adspRegion: null,
    subOptions: [
      {
        name: "Standard",
        viewPer: "basic_analytics",
        group: "standard_analytics",
        navLink: "/analytics/standard-analytics",
        faIconClass: null,
        matIconClass: "bar_chart",
        adspRegion: null,
      },
      {
        name: "Advanced",
        viewPer: "need_to_permissions_later_qqq_111_000",
        group: "advanced_analytics",
        navLink: "/analytics/advanced-analytics",
        faIconClass: null,
        matIconClass: "multiline_chart",
        adspRegion: null,
      },
    ],
  },
  {
    name: "Platform Libraries",
    listPer: "platform_inventory_list",
    navLink: "/inventory",
    faIconClass: null,
    matIconClass: "library_books",
    entityGroup: "all",
    children: [
      {
        name: "Global",
        toolTip: "Global Audiences, Global Inventory (Including CTV and OTT)",
        listPer: "platform_inventory_list",
        group: "tdsp_libraries",
        navLink: "/tdsp/segments",
        faIconClass: "fas fa-globe me-3",
        matIconClass: null,
        adspRegion: null,
        children: [
          {
            name: "Segments",
            listPer: "platform_segment",
            group: "tdsp_seg",
            navLink: "/tdsp/segments",
            faIconClass: null,
            matIconClass: "my_location",
          },
          {
            name: "Deals",
            listPer: "deal_admin_view",
            group: "tdsp_deals",
            navLink: "/tdsp/deals",
            faIconClass: null,
            matIconClass: "local_offer",
          },
          {
            name: "Inventory Lists",
            listPer: "platform_inventory_list",
            group: "tdsp_inventory_list",
            navLink: "/tdsp/inventory-list",
            faIconClass: null,
            matIconClass: "list",
          },
          {
            name: "Contextual Keywords",
            listPer: "platform_inventory_list",
            group: "tdsp_contextual_keyword",
            navLink: "/tdsp/contextual-keywords",
            faIconClass: null,
            matIconClass: "list",
          },
        ],
      },
      {
        name: "Global - Old",
        toolTip:
          "Global Audiences, Global Inventory (Including CTV and OTT) and Netflix Premium",
        listPer: "platform_inventory_list",
        group: "libraries",
        navLink: "/inventory",
        faIconClass: null,
        matIconClass: "inventory_2",
        adspRegion: null,
        children: [
          {
            name: "Inventory Lists",
            listPer: "platform_inventory_list",
            group: "inventory_list",
            navLink: "/inventory",
            faIconClass: null,
            matIconClass: "list",
          },
          {
            name: "Segments",
            listPer: "platform_segment",
            group: "segment_pixel",
            navLink: "/segment-pixel",
            faIconClass: null,
            matIconClass: "my_location",
          },
          {
            name: "Deals",
            listPer: "deal_admin_view",
            group: "deals",
            navLink: "/deals",
            faIconClass: null,
            matIconClass: "local_offer",
          },
          {
            name: "Custom Locations",
            listPer: "platform_cll",
            group: "custom_locations",
            navLink: "/custom-location",
            faIconClass: null,
            matIconClass: "location_on",
          },
        ],
      },
      {
        name: "US Amazon",
        toolTip:
          "Amazon Audiences, Amazon Inventory including Prime Video in the US",
        listPer: "deal_admin_view",
        group: "adsp_libraries_us",
        navLink: "/adsp/deals",
        faIconClass: null,
        matIconClass: null,
        textIcon: "a",
        adspRegion: "US",
        children: [
          {
            name: "Deals",
            listPer: "deal_admin_view",
            group: "adsp_deals",
            navLink: "/adsp/deals",
            faIconClass: null,
            matIconClass: "local_offer",
            adspRegion: "US",
          },
        ],
      },
      {
        name: "EU Amazon",
        toolTip:
          "Amazon Audiences, Amazon Inventory including Prime Video in the EU",
        listPer: "deal_admin_view",
        group: "adsp_libraries_eu",
        navLink: "/adsp/deals",
        faIconClass: null,
        matIconClass: null,
        textIcon: "a",
        adspRegion: "EU",
        children: [
          {
            name: "Deals",
            listPer: "deal_admin_view",
            group: "adsp_deals",
            navLink: "/adsp/deals",
            faIconClass: null,
            matIconClass: "local_offer",
            adspRegion: "EU",
          },
        ],
      },
      {
        name: "Restricted Inventory",
        // toolTip: "Crypto, Political Categories",
        toolTip:
          "Restricted Global Audiences, Restricted Inventory (Including CTV and OTT)",
        listPer: "platform_inventory_list",
        group: "bdsp_libraries",
        navLink: "/bdsp/custom-list",
        faIconClass: "fas fa-user-shield me-3",
        matIconClass: null,
        adspRegion: null,
        children: [
          {
            name: "Custom Lists",
            listPer: "platform_inventory_list",
            group: "bdsp_cl",
            navLink: "/bdsp/custom-list",
            faIconClass: null,
            matIconClass: "list",
          },
          {
            name: "Segments",
            listPer: "platform_segment",
            group: "bdsp_seg",
            navLink: "/bdsp/segment-pixel",
            faIconClass: null,
            matIconClass: "my_location",
          },
          {
            name: "Deals",
            listPer: "deal_admin_view",
            group: "bdsp_deals",
            navLink: "/bdsp/deals",
            faIconClass: null,
            matIconClass: "local_offer",
          },
        ],
      },
    ],
  },
  {
    name: "P&L Report",
    listPer: "report",
    navLink: "/report/create",
    faIconClass: "fas fa-coins me-3",
    matIconClass: null,
    entityGroup: "pl",
    children: [
      {
        name: "Global",
        toolTip: "Global Audiences, Global Inventory (Including CTV and OTT)",
        listPer: "report",
        dspType: "tdsp",
        group: "tdsp_reports",
        navLink: "/tdsp/report/create",
        faIconClass: "fas fa-globe me-3",
        matIconClass: null,
        adspRegion: null,
        children: [
          {
            name: "Generate P&L Reports",
            listPer: "report",
            group: "tdsp_generate_report",
            navLink: "tdsp/report/create",
            faIconClass: null,
            matIconClass: "list",
          },
          {
            name: "View P&L Reports",
            listPer: "report",
            group: "tdsp_view_report",
            faIconClass: null,
            matIconClass: "bar_chart",
          },
        ],
      },
      {
        name: "Global - Old",
        toolTip:
          "Global Audiences, Global Inventory (Including CTV and OTT) and Netflix Premium",
        listPer: "report",
        dspType: "vdsp",
        group: "vdsp_reports",
        navLink: "/report/create",
        faIconClass: null,
        matIconClass: "inventory_2",
        adspRegion: null,
        children: [
          {
            name: "Generate P&L Reports",
            listPer: "report",
            group: "vdsp_generate_report",
            navLink: "/report/create",
            faIconClass: null,
            matIconClass: "list",
          },
          {
            name: "View P&L Reports",
            listPer: "report",
            group: "vdsp_view_report",
            faIconClass: null,
            matIconClass: "bar_chart",
          },
        ],
      },
      {
        name: "US Amazon",
        toolTip:
          "Amazon Audiences, Amazon Inventory including Prime Video in the US",
        listPer: "report",
        dspType: "adsp_us",
        group: "adsp_reports_us",
        navLink: "/adsp/report/create",
        faIconClass: null,
        matIconClass: null,
        textIcon: "a",
        adspRegion: "US",
        children: [
          {
            name: "Generate P&L Reports",
            listPer: "report",
            group: "adsp_generate_report_us",
            navLink: "/adsp/report/create",
            faIconClass: null,
            matIconClass: "list",
            adspRegion: "US",
          },
          {
            name: "View P&L Reports",
            listPer: "report",
            group: "adsp_view_report_us",
            faIconClass: null,
            matIconClass: "bar_chart",
            adspRegion: "US",
          },
        ],
      },
      {
        name: "EU Amazon",
        toolTip:
          "Amazon Audiences, Amazon Inventory including Prime Video in the EU",
        listPer: "report",
        dspType: "adsp_eu",
        group: "adsp_reports_eu",
        navLink: "/adsp/report/create",
        faIconClass: null,
        matIconClass: null,
        textIcon: "a",
        adspRegion: "EU",
        children: [
          {
            name: "Generate P&L Reports",
            listPer: "report",
            group: "adsp_generate_report_eu",
            navLink: "/adsp/report/create",
            faIconClass: null,
            matIconClass: "list",
            adspRegion: "EU",
          },
          {
            name: "View P&L Reports",
            listPer: "report",
            group: "adsp_view_report_eu",
            faIconClass: null,
            matIconClass: "bar_chart",
            adspRegion: "EU",
          },
        ],
      },
      {
        name: "Restricted Inventory",
        // toolTip: "Crypto, Political Categories",
        toolTip:
          "Restricted Global Audiences, Restricted Inventory (Including CTV and OTT)",
        listPer: "report",
        dspType: "bdsp",
        group: "bdsp_reports",
        navLink: "/bdsp/report/create",
        faIconClass: "fas fa-user-shield me-3",
        matIconClass: null,
        adspRegion: null,
        children: [
          {
            name: "Generate P&L Reports",
            listPer: "report",
            group: "bdsp_generate_report",
            navLink: "/bdsp/report/create",
            faIconClass: null,
            matIconClass: "list",
          },
          {
            name: "View P&L Reports",
            listPer: "report",
            group: "bdsp_view_report",
            faIconClass: null,
            matIconClass: "bar_chart",
          },
        ],
      },
    ],
  },
  {
    name: "CDP",
    dspType: "nonDSP",
    listPer: "advertiser",
    entity: "cdp",
    group: "cdp",
    navLink: "",
    faIconClass: "fas fa-users me-3",
    matIconClass: null,
  },
];

export const agencyLevelMenu = [
  {
    name: "Campaign Management & Reporting",
    listPer: "agency_advertiser",
    navLink: "/agency-advertiser",
    faIconClass: "fab fa-adversal me-3",
    liteNavLink: "/campaign",
    reportNavLink: "/report",
    matIconClass: null,
    entityGroup: "all",
    children: [
      {
        name: "Global",
        toolTip:
          "Global Audiences, Global Inventory (Including CTV and OTT) and Netflix Premium",
        dspType: "tdsp",
        listPer: "agency_advertiser",
        group: "agency_advertisers",
        navLink: "/tdsp/dashboard",
        faIconClass: "fas fa-globe me-3",
        matIconClass: null,
        children: [
          {
            name: "Agency Dashboard",
            listPer: "report",
            group: "dashboard",
            navLink: "/tdsp/dashboard",
            faIconClass: null,
            matIconClass: "dashboard",
            navigation: true,
          },
          {
            name: "Agency Advertisers",
            listPer: "agency_advertiser",
            group: "agency_advertisers",
            navLink: "/tdsp/agency-advertiser",
            faIconClass: "fas fa-user-friends me-3",
            matIconClass: null,
            navigation: true,
          },
          {
            name: "Agency Libraries",
            listPer: "libraries_lsnav",
            group: "tdsp_libraries",
            navLink: "/tdsp/inventory-list",
            faIconClass: null,
            matIconClass: "library_books",
            navigation: true,
            adspRegion: null,
            children: [
              {
                name: "Agency Inventory Lists",
                listPer: "agency_inventory_list",
                group: "tdsp_inventory_list",
                navLink: "/tdsp/inventory-list",
                faIconClass: null,
                matIconClass: "list",
                navigation: true,
              },
              {
                name: "Agency Deals",
                listPer: "deal_client_view",
                group: "tdsp_deals",
                navLink: "/tdsp/deals",
                faIconClass: null,
                matIconClass: "local_offer",
                navigation: true,
              },
              {
                name: "Agency Contextual Keywords",
                listPer: "agency_inventory_list",
                group: "tdsp_contextual_keyword",
                navLink: "/tdsp/contextual-keywords",
                faIconClass: null,
                matIconClass: "list",
                navigation: true,
              },
            ],
          },
          {
            name: "Agency Reports",
            listPer: "report",
            group: "tdsp_reports",
            navLink: "/tdsp/report/create",
            faIconClass: "fas fa-chart-line me-4",
            matIconClass: null,
            children: [
              {
                name: "Generate Agency Reports",
                listPer: "report",
                group: "tdsp_generate_report",
                navLink: "/tdsp/report/create",
                faIconClass: null,
                matIconClass: "insert_chart_outlined",
              },
              {
                name: "Manage Agency Reports",
                listPer: "report",
                group: "tdsp_manage_report",
                navLink: "/tdsp/report",
                faIconClass: null,
                matIconClass: "table_chart",
              },
              {
                name: "View Agency Reports",
                listPer: "report",
                group: "tdsp_view_report",
                viewReport: true,
                faIconClass: null,
                matIconClass: "bar_chart",
              },
            ],
          },
        ],
      },
      {
        name: "Global - Old",
        toolTip:
          "Global Audiences, Global Inventory (Including CTV and OTT) and Netflix Premium",
        dspType: "vdsp",
        listPer: "agency_advertiser",
        group: "agency_advertisers",
        navLink: "/agency-advertiser",
        faIconClass: null,
        matIconClass: "inventory_2",
        children: [
          {
            name: "Agency Advertisers",
            listPer: "agency_advertiser",
            group: "agency_advertisers",
            navLink: "/agency-advertiser",
            faIconClass: "fas fa-user-friends me-3",
            matIconClass: null,
            navigation: true,
          },
          {
            name: "Agency Libraries",
            listPer: "libraries_lsnav",
            group: "libraries",
            navLink: "/inventory",
            faIconClass: null,
            matIconClass: "library_books",
            navigation: true,
            children: [
              {
                name: "Agency Inventory Lists",
                listPer: "agency_inventory_list",
                group: "inventory_list",
                navLink: "/inventory",
                faIconClass: null,
                matIconClass: "list",
                navigation: true,
              },
              {
                name: "Agency Segments",
                listPer: "agency_segment",
                group: "segment_pixel",
                navLink: "/segment-pixel",
                faIconClass: null,
                matIconClass: "my_location",
                navigation: true,
              },
              {
                name: "Agency Deals",
                listPer: "deal_client_view",
                group: "deals",
                navLink: "/deals",
                faIconClass: null,
                matIconClass: "local_offer",
                navigation: true,
              },
              {
                name: "Agency Custom Locations",
                listPer: "agency_cll",
                group: "custom_locations",
                navLink: "/custom-location",
                faIconClass: null,
                matIconClass: "location_on",
                navigation: true,
              },
            ],
          },
          {
            name: "Analytics",
            // viewPer: "basic_analytics", uncomment once we support analytics.
            viewPer: "xxx_basic_analytics_xxx",
            group: "analytics",
            navLink: "/analytics/standard-analytics",
            faIconClass: null,
            matIconClass: "pie_chart",
            adspRegion: null,
            children: [
              {
                name: "Standard",
                viewPer: "basic_analytics",
                group: "standard_analytics",
                navLink: "/analytics/standard-analytics",
                faIconClass: null,
                matIconClass: "bar_chart",
                adspRegion: null,
              },
              {
                name: "Advanced",
                viewPer: "need_to_permissions_later_qqq_111_000",
                group: "advanced_analytics",
                navLink: "/analytics/advanced-analytics",
                faIconClass: null,
                matIconClass: "multiline_chart",
                adspRegion: null,
              },
            ],
          },
          {
            name: "Agency Reports",
            listPer: "report",
            group: "reports",
            navLink: "/report/create",
            faIconClass: "fas fa-chart-line me-4",
            matIconClass: null,
            adspRegion: null,
            children: [
              {
                name: "Generate Agency Reports",
                listPer: "report",
                group: "generate_report",
                navLink: "/report/create",
                faIconClass: null,
                matIconClass: "insert_chart_outlined",
                adspRegion: null,
              },
              {
                name: "Manage Agency Reports",
                listPer: "report",
                group: "manage_report",
                navLink: "/report",
                faIconClass: null,
                matIconClass: "table_chart",
                adspRegion: null,
              },
              {
                name: "View Agency Reports",
                listPer: "report",
                group: "view_report",
                viewReport: true,
                faIconClass: null,
                matIconClass: "bar_chart",
                adspRegion: null,
              },
            ],
          },
        ],
      },
      {
        name: "US Amazon",
        toolTip:
          "Amazon Audiences, Amazon Inventory including Prime Video in the US",
        dspType: "adsp_us",
        listPer: "agency_advertiser",
        group: "agency_advertisers",
        navLink: "/adsp/agency-advertiser",
        faIconClass: null,
        matIconClass: null,
        textIcon: "a",
        adspRegion: "US",
        children: [
          {
            name: "Agency Dashboard",
            listPer: "report",
            group: "dashboard",
            navLink: "",
            faIconClass: null,
            matIconClass: "dashboard",
            navigation: true,
          },
          {
            name: "Agency Advertisers",
            listPer: "agency_advertiser",
            group: "agency_advertisers",
            navLink: "/adsp/agency-advertiser",
            faIconClass: "fas fa-user-friends me-3",
            matIconClass: null,
            navigation: true,
            adspRegion: "US",
          },
          {
            name: "Agency Libraries",
            listPer: "libraries_lsnav",
            group: "adsp_libraries",
            navLink: "/adsp/inventory",
            faIconClass: null,
            matIconClass: "library_books",
            navigation: true,
            adspRegion: "US",
            children: [
              {
                name: "Agency Inventory Lists",
                listPer: "agency_inventory_list",
                group: "adsp_il",
                navLink: "/adsp/inventory",
                faIconClass: null,
                matIconClass: "list",
                navigation: true,
                adspRegion: "US",
              },
              {
                name: "Agency Deals",
                listPer: "deal_client_view",
                group: "adsp_deals",
                navLink: "/adsp/deals",
                faIconClass: null,
                matIconClass: "local_offer",
                navigation: true,
                adspRegion: "US",
              },
            ],
          },
          {
            name: "Agency Reports",
            listPer: "report",
            group: "adsp_reports",
            navLink: "/adsp/report/create",
            faIconClass: "fas fa-chart-line me-4",
            matIconClass: null,
            adspRegion: "US",
            children: [
              {
                name: "Generate Agency Reports",
                listPer: "report",
                group: "adsp_generate_report",
                navLink: "/adsp/report/create",
                faIconClass: null,
                matIconClass: "insert_chart_outlined",
                adspRegion: "US",
              },
              {
                name: "Manage Agency Reports",
                listPer: "report",
                group: "adsp_manage_report",
                navLink: "/adsp/report",
                faIconClass: null,
                matIconClass: "table_chart",
                adspRegion: "US",
              },
              {
                name: "View Agency Reports",
                listPer: "report",
                group: "adsp_view_report",
                viewReport: true,
                faIconClass: null,
                matIconClass: "bar_chart",
                adspRegion: "US",
              },
            ],
          },
        ],
      },
      {
        name: "EU Amazon",
        toolTip:
          "Amazon Audiences, Amazon Inventory including Prime Video in the EU",
        dspType: "adsp_eu",
        listPer: "agency_advertiser",
        group: "agency_advertisers",
        navLink: "/adsp/agency-advertiser",
        faIconClass: null,
        matIconClass: null,
        textIcon: "a",
        adspRegion: "EU",
        children: [
          {
            name: "Agency Dashboard",
            listPer: "report",
            group: "dashboard",
            navLink: "",
            faIconClass: null,
            matIconClass: "dashboard",
            navigation: true,
          },
          {
            name: "Agency Advertisers",
            listPer: "agency_advertiser",
            group: "agency_advertisers",
            navLink: "/adsp/agency-advertiser",
            faIconClass: "fas fa-user-friends me-3",
            matIconClass: null,
            navigation: true,
            adspRegion: "EU",
          },
          {
            name: "Agency Libraries",
            listPer: "libraries_lsnav",
            group: "adsp_libraries",
            navLink: "/adsp/inventory",
            faIconClass: null,
            matIconClass: "library_books",
            navigation: true,
            adspRegion: "EU",
            children: [
              {
                name: "Agency Inventory Lists",
                listPer: "agency_inventory_list",
                group: "adsp_il",
                navLink: "/inventory",
                faIconClass: null,
                matIconClass: "list",
                navigation: true,
                adspRegion: "EU",
              },
              {
                name: "Agency Deals",
                listPer: "deal_client_view",
                group: "adsp_deals",
                navLink: "/adsp/deals",
                faIconClass: null,
                matIconClass: "local_offer",
                navigation: true,
                adspRegion: "EU",
              },
            ],
          },
          {
            name: "Agency Reports",
            listPer: "report",
            group: "adsp_reports",
            navLink: "/adsp/report/create",
            faIconClass: "fas fa-chart-line me-4",
            matIconClass: null,
            adspRegion: "EU",
            children: [
              {
                name: "Generate Agency Reports",
                listPer: "report",
                group: "adsp_generate_report",
                navLink: "/adsp/report/create",
                faIconClass: null,
                matIconClass: "insert_chart_outlined",
                adspRegion: "EU",
              },
              {
                name: "Manage Agency Reports",
                listPer: "report",
                group: "adsp_manage_report",
                navLink: "/adsp/report",
                faIconClass: null,
                matIconClass: "table_chart",
                adspRegion: "EU",
              },
              {
                name: "View Agency Reports",
                listPer: "report",
                group: "adsp_view_report",
                viewReport: true,
                faIconClass: null,
                matIconClass: "bar_chart",
                adspRegion: "EU",
              },
            ],
          },
        ],
      },
      {
        name: "Restricted Inventory",
        // toolTip: "Crypto, Political Categories",
        toolTip:
          "Restricted Global Audiences, Restricted Inventory (Including CTV and OTT)",
        dspType: "bdsp",
        listPer: "agency_advertiser",
        group: "agency_advertisers",
        navLink: "/bdsp/agency-advertiser",
        faIconClass: "fas fa-user-shield me-3",
        matIconClass: null,
        children: [
          {
            name: "Agency Dashboard",
            listPer: "report",
            group: "dashboard",
            navLink: "",
            faIconClass: null,
            matIconClass: "dashboard",
            navigation: true,
          },
          {
            name: "Agency Advertisers",
            listPer: "agency_advertiser",
            group: "agency_advertisers",
            navLink: "/bdsp/agency-advertiser",
            faIconClass: "fas fa-user-friends me-3",
            matIconClass: null,
            navigation: true,
          },
          {
            name: "Agency Libraries",
            listPer: "libraries_lsnav",
            group: "bdsp_libraries",
            navLink: "/bdsp/custom-list",
            faIconClass: null,
            matIconClass: "library_books",
            navigation: true,
            adspRegion: null,
            children: [
              {
                name: "Agency Custom Lists",
                listPer: "agency_inventory_list",
                group: "bdsp_cl",
                navLink: "/bdsp/custom-list",
                faIconClass: null,
                matIconClass: "list",
                navigation: true,
              },
              {
                name: "Agency Segments",
                isPlatformEntity: true,
                listPer: "agency_segment",
                group: "bdsp_seg",
                navLink: "/bdsp/segment-pixel",
                faIconClass: null,
                matIconClass: "my_location",
                navigation: true,
              },
              {
                name: "Agency Deals",
                listPer: "deal_client_view",
                group: "bdsp_deals",
                navLink: "/bdsp/deals",
                faIconClass: null,
                matIconClass: "local_offer",
                navigation: true,
                adspRegion: "US",
              },
            ],
          },
          {
            name: "Agency Reports",
            listPer: "report",
            group: "bdsp_reports",
            navLink: "/bdsp/report/create",
            faIconClass: "fas fa-chart-line me-4",
            matIconClass: null,
            children: [
              {
                name: "Generate Agency Reports",
                listPer: "report",
                group: "bdsp_generate_report",
                navLink: "/bdsp/report/create",
                faIconClass: null,
                matIconClass: "insert_chart_outlined",
              },
              {
                name: "Manage Agency Reports",
                listPer: "report",
                group: "bdsp_manage_report",
                navLink: "/bdsp/report",
                faIconClass: null,
                matIconClass: "table_chart",
              },
              {
                name: "View Agency Reports",
                listPer: "report",
                group: "bdsp_view_report",
                viewReport: true,
                faIconClass: null,
                matIconClass: "bar_chart",
              },
            ],
          },
        ],
      },
      {
        name: "Hyperlocal",
        toolTip:
          "Global Audiences, Global Inventory (Including CTV and OTT) and Netflix Premium",
        dspType: "tdsp_hyperlocal",
        listPer: "agency_advertiser",
        group: "agency_advertisers",
        navLink: "/tdsp-hyperlocal/agency-advertiser",
        faIconClass: "fas fa-globe me-3",
        matIconClass: null,
        children: [
          {
            name: "Agency Dashboard",
            listPer: "report",
            group: "dashboard",
            navLink: "",
            faIconClass: null,
            matIconClass: "dashboard",
            navigation: true,
          },
          {
            name: "Agency Advertisers",
            listPer: "agency_advertiser",
            group: "agency_advertisers",
            navLink: "/tdsp-hyperlocal/agency-advertiser",
            faIconClass: "fas fa-user-friends me-3",
            matIconClass: null,
            navigation: true,
          },
          {
            name: "Agency Libraries",
            listPer: "libraries_lsnav",
            group: "tdsp_libraries",
            navLink: "/tdsp-hyperlocal/inventory-list",
            faIconClass: null,
            matIconClass: "library_books",
            navigation: true,
            adspRegion: null,
            children: [
              {
                name: "Agency Deals",
                listPer: "deal_client_view",
                group: "tdsp_deals",
                navLink: "/tdsp-hyperlocal/deals",
                faIconClass: null,
                matIconClass: "local_offer",
                navigation: true,
              },
              {
                name: "Agency Inventory Lists",
                listPer: "agency_inventory_list",
                group: "tdsp_inventory_list",
                navLink: "/tdsp-hyperlocal/inventory-list",
                faIconClass: null,
                matIconClass: "list",
                navigation: true,
              },
              {
                name: "Agency Contextual Keywords",
                listPer: "agency_inventory_list",
                group: "tdsp_contextual_keyword",
                navLink: "/tdsp-hyperlocal/contextual-keywords",
                faIconClass: null,
                matIconClass: "list",
                navigation: true,
              },
            ],
          },
          {
            name: "Agency Reports",
            listPer: "report",
            group: "tdsp_reports",
            navLink: "/tdsp-hyperlocal/report/create",
            faIconClass: "fas fa-chart-line me-4",
            matIconClass: null,
            children: [
              {
                name: "Generate Agency Reports",
                listPer: "report",
                group: "tdsp_generate_report",
                navLink: "/tdsp-hyperlocal/report/create",
                faIconClass: null,
                matIconClass: "insert_chart_outlined",
              },
              {
                name: "Manage Agency Reports",
                listPer: "report",
                group: "tdsp_manage_report",
                navLink: "/tdsp-hyperlocal/report",
                faIconClass: null,
                matIconClass: "table_chart",
              },
              {
                name: "View Agency Reports",
                listPer: "report",
                group: "tdsp_view_report",
                viewReport: true,
                faIconClass: null,
                matIconClass: "bar_chart",
              },
            ],
          },
        ],
      }
    ],
  },
  {
    name: "CDP",
    dspType: "nonDSP",
    listPer: "agency_user",
    entity: "cdp",
    group: "cdp",
    navLink: "",
    faIconClass: "fas fa-users me-3",
    matIconClass: null,
  },
  {
    name: "Users",
    dspType: "nonDSP",
    listPer: "agency_user",
    group: "users",
    entity: "users",
    navLink: "/user",
    faIconClass: "fas fa-users me-3",
    matIconClass: null,
  },
  {
    name: "My Accounts",
    dspType: "nonDSP",
    viewPer: "account_statement",
    group: "account_statement",
    entity: "account_statement",
    navLink: "/account-statement",
    faIconClass: "fas fa-wallet me-3",
    matIconClass: null,
  },
];

export const advertiserLevelMenu = [
  {
    name: "Campaign Management & Reporting",
    listPer: "campaign_lsnav",
    navLink: "/insertion-order",
    liteNavLink: "/campaign",
    reportNavLink: "/report",
    faIconClass: "fab fa-adversal me-3",
    matIconClass: null,
    entityGroup: "all",
    children: [
      {
        name: "Global",
        toolTip:
          "Global Audiences, Global Inventory (Including CTV and OTT) and Netflix Premium",
        dspType: "tdsp",
        listPer: "campaign_lsnav",
        navLink: "/tdsp/dashboard",
        liteNavLink: "/tdsp/campaign",
        reportNavLink: "/tdsp/report",
        faIconClass: "fas fa-globe me-3",
        matIconClass: null,
        adspRegion: null,
        children: [
          {
            name: "Dashboard",
            listPer: "report",
            group: "tdsp_dashboard",
            navLink: "/tdsp/dashboard",
            faIconClass: null,
            matIconClass: "dashboard",
            navigation: true,
          },
          {
            name: "Campaigns",
            listPer: "campaign_lsnav",
            group: "tdsp_campaigns",
            entity: "insertion_order",
            navLink: "/tdsp/insertion-order",
            faIconClass: "fas me-3 fa-bullhorn",
            matIconClass: null,
            navigation: true,
            children: [
              {
                name: "Insertion Orders",
                listPer: "campaign_lsnav",
                group: "tdsp_io",
                navLink: "/tdsp/insertion-order",
                faIconClass: "fas fa-money-check",
                matIconClass: null,
                navigation: true,
              },
              {
                name: "Line Items",
                listPer: "line_item",
                group: "tdsp_li",
                navLink: "/tdsp/campaign",
                faIconClass: "fas fa-bullhorn",
                matIconClass: null,
                navigation: true,
              },
            ],
          },
          {
            name: "Media Plan",
            listPer: "forecasting_plan",
            group: "tdsp_forecasting_plan",
            navLink: "/tdsp/media-plan",
            faIconClass: "fas fa-money-check me-3",
            matIconClass: null,
            navigation: true,
            entity: "media_plan",
            badge: "beta",
            navLinkTwo: "/tdsp/media-plan",
            children: [
              {
                name: "Media Plan",
                listPer: "forecasting_plan",
                group: "tdsp_media_plan",
                navLink: "/tdsp/media-plan",
                faIconClass: "fas fa-money-check",
                matIconClass: null,
                navigation: true,
              },
              {
                name: "View Media Plan Forecast",
                listPer: "forecasting_plan",
                group: "tdsp_view_media_plan",
                faIconClass: "fas fa-money-check",
                matIconClass: null,
                navigation: true,
              }
            ],
          },
          {
            name: "Libraries",
            listPer: "libraries_lsnav",
            group: "tdsp_libraries",
            entity: "inventory_list",
            navLink: "/tdsp/creative",
            navLinkTwo: "/tdsp/creative",
            faIconClass: null,
            matIconClass: "library_books",
            navigation: true,
            children: [
              {
                name: "Creatives",
                listPer: "creative",
                isPlatformEntity: false,
                agAdvLstPrm: null,
                advLstPrm: null,
                group: "tdsp_crtv",
                navLink: "/tdsp/creative",
                entity: null,
                faIconClass: "fas fa-ad ms-1",
                matIconClass: null,
                navigation: true,
              },
              {
                name: "Conversion Pixels",
                listPer: "pixel",
                isPlatformEntity: false,
                agAdvLstPrm: null,
                advLstPrm: null,
                group: "tdsp_pixel",
                navLink: "/tdsp/conversion-pixel",
                entity: null,
                faIconClass: null,
                matIconClass: "track_changes",
                navigation: true,
              },
              {
                name: "Custom Locations",
                isPlatformEntity: true,
                agAdvLstPrm: "agadv_cll",
                advLstPrm: "advertiser_cll",
                entity: "custom_location",
                group: "custom_locations",
                navLink: "/tdsp/custom-location",
                faIconClass: null,
                matIconClass: "location_on",
                navigation: true,
              },
              {
                name: "Deals",
                listPer: "deal_client_view",
                isPlatformEntity: true,
                advLstPrm: "advertiser_user",
                agAdvLstPrm: null,
                group: "tdsp_deals",
                navLink: "/tdsp/deals",
                entity: "deals",
                faIconClass: null,
                matIconClass: "local_offer",
                navigation: true,
              },
              {
                name: "Inventory Lists",
                listPer: "platform_inventory_list",
                isPlatformEntity: false,
                agAdvLstPrm: null,
                advLstPrm: null,
                entity: "null",
                group: "tdsp_inventory_list",
                navLink: "/tdsp/inventory-list",
                faIconClass: null,
                matIconClass: "list",
                navigation: true,
              },
              {
                name: "Content Category Lists",
                listPer: "platform_inventory_list",
                isPlatformEntity: false,
                agAdvLstPrm: null,
                advLstPrm: null,
                entity: "null",
                group: "tdsp_inventory_category",
                navLink: "/tdsp/content-category",
                faIconClass: null,
                matIconClass: "tv_off",
                navigation: true,
              },
              {
                name: "Contextual Keywords",
                listPer: "libraries_lsnav",
                isPlatformEntity: true,
                agAdvLstPrm: "agadv_inventory_list",
                advLstPrm: "advertiser_inventory_list",
                entity: "tdsp_contextual_keyword",
                group: "tdsp_contextual_keyword",
                navLink: "/tdsp/contextual-keywords",
                faIconClass: null,
                matIconClass: "text_snippet",
                navigation: true,
              },
            ],
          },
          {
            name: "Offline Attribution Libraries",
            listPer: "libraries_lsnav",
            group: "offline_libraries",
            entity: "coupon_code",
            navLink: "tdsp/coupon-code",
            faIconClass: null,
            matIconClass: "library_books",
            navigation: true,
            children: [
              {
                name: "Coupon Codes",
                listPer: "coupon_code",
                isPlatformEntity: false,
                agAdvLstPrm: null,
                advLstPrm: null,
                group: "coupon_code",
                navLink: "tdsp/coupon-code",
                entity: "coupon_code",
                faIconClass: null,
                matIconClass: "code",
                navigation: true,
              },
              {
                name: "Stores",
                listPer: "store",
                isPlatformEntity: false,
                agAdvLstPrm: null,
                advLstPrm: null,
                group: "store",
                navLink: "tdsp/store",
                entity: "store",
                faIconClass: null,
                matIconClass: "store",
                navigation: true,
              },
            ],
          },
          {
            name: "Data Hub",
            listPer: "libraries_lsnav",
            group: "data_hub",
            entity: "segment",
            navLink: "/tdsp/segments",
            faIconClass: null,
            matIconClass: "device_hub",
            navigation: true,
            children: [
              {
                name: "Data Collection",
                isPlatformEntity: true,
                agAdvLstPrm: "agadv_segment",
                advLstPrm: "advertiser_segment",
                group: "tdsp_seg",
                navLink: "/tdsp/segments",
                entity: null,
                faIconClass: null,
                matIconClass: "my_location",
                navigation: true,
              },
              {
                name: "Seeds",
                listPer: "seed",
                isPlatformEntity: false,
                agAdvLstPrm: null,
                advLstPrm: null,
                entity: "null",
                group: "seed",
                navLink: "/tdsp/seed",
                faIconClass: null,
                matIconClass: "spa",
                navigation: true,
              },
              {
                name: "Audience Builder",
                listPer: "creative",
                isPlatformEntity: false,
                agAdvLstPrm: null,
                advLstPrm: null,
                entity: "null",
                group: "audience_builder",
                navLink: "/tdsp/audience-builder",
                faIconClass: null,
                matIconClass: "group",
                navigation: true,
              },
            ],
          },
          {
            name: "Reports",
            listPer: "report",
            entity: "reports",
            group: "tdsp_reports",
            navLink: "/tdsp/report/create",
            faIconClass: "fas fa-chart-line me-4",
            matIconClass: null,
            children: [
              {
                name: "Generate Reports",
                listPer: "report",
                group: "tdsp_generate_report",
                navLink: "/tdsp/report/create",
                faIconClass: null,
                matIconClass: "insert_chart_outlined",
              },
              {
                name: "Manage Reports",
                listPer: "report",
                group: "tdsp_manage_report",
                navLink: "/tdsp/report",
                faIconClass: null,
                matIconClass: "table_chart",
              },
              {
                name: "View Reports",
                listPer: "report",
                group: "tdsp_view_report",
                viewReport: true,
                faIconClass: null,
                matIconClass: "bar_chart",
              },
            ],
          },
        ],
      },
      {
        name: "Global - Old",
        toolTip:
          "Global Audiences, Global Inventory (Including CTV and OTT) and Netflix Premium",
        dspType: "vdsp",
        listPer: "campaign_lsnav",
        navLink: "/insertion-order",
        liteNavLink: "/campaign",
        reportNavLink: "/report",
        faIconClass: null,
        matIconClass: "inventory_2",
        children: [
          {
            name: "Campaigns",
            listPer: "campaign_lsnav",
            entity: "campaign",
            group: "political",
            navLink: "/campaign",
            faIconClass: "fas fa-bullhorn",
            matIconClass: null,
            navigation: true,
          },
          {
            name: "Campaigns",
            listPer: "campaign_lsnav",
            group: "campaigns",
            entity: "insertion_order",
            navLink: "/insertion-order",
            faIconClass: "fas me-3 fa-bullhorn",
            matIconClass: null,
            navigation: true,
            children: [
              {
                name: "Insertion Orders",
                listPer: "campaign_lsnav",
                group: "io",
                navLink: "/insertion-order",
                faIconClass: "fas fa-money-check",
                matIconClass: null,
                navigation: true,
              },
              {
                name: "Line Items",
                listPer: "line_item",
                group: "ali",
                navLink: "/campaign",
                faIconClass: "fas fa-bullhorn",
                matIconClass: null,
                navigation: true,
              },
            ],
          },
          {
            name: "Libraries",
            listPer: "libraries_lsnav",
            group: "libraries",
            entity: "inventory_list",
            navLink: "/inventory",
            navLinkTwo: "/segment-pixel",
            faIconClass: null,
            matIconClass: "library_books",
            navigation: true,
            children: [
              {
                name: "Inventory Lists",
                listPer: "libraries_lsnav",
                isPlatformEntity: true,
                agAdvLstPrm: "agadv_inventory_list",
                advLstPrm: "advertiser_inventory_list",
                entity: "inventory_list",
                group: "inventory_list",
                navLink: "/inventory",
                faIconClass: null,
                matIconClass: "list",
                navigation: true,
              },
              {
                name: "Segments",
                isPlatformEntity: true,
                agAdvLstPrm: "agadv_segment",
                advLstPrm: "advertiser_segment",
                group: "segment_pixel",
                navLink: "/segment-pixel",
                entity: null,
                faIconClass: null,
                matIconClass: "my_location",
                navigation: true,
              },
              {
                name: "Conversion Pixels",
                listPer: "pixel",
                isPlatformEntity: false,
                agAdvLstPrm: null,
                advLstPrm: null,
                group: "convertion_pixels",
                navLink: "/conversion-pixel",
                entity: null,
                faIconClass: null,
                matIconClass: "track_changes",
                navigation: true,
              },
              {
                name: "Creatives",
                listPer: "creative",
                isPlatformEntity: false,
                agAdvLstPrm: null,
                advLstPrm: null,
                group: "creative",
                navLink: "/creatives",
                entity: null,
                faIconClass: "fas fa-ad ms-1",
                matIconClass: null,
                navigation: true,
              },
              {
                name: "Deals",
                listPer: "deal_client_view",
                isPlatformEntity: true,
                advLstPrm: "advertiser_user",
                agAdvLstPrm: null,
                group: "deals",
                navLink: "/deals",
                entity: "deals",
                faIconClass: null,
                matIconClass: "local_offer",
                navigation: true,
              },
              {
                name: "Custom Locations",
                isPlatformEntity: true,
                agAdvLstPrm: "agadv_cll",
                advLstPrm: "advertiser_cll",
                entity: "custom_location",
                group: "custom_locations",
                navLink: "/custom-location",
                faIconClass: null,
                matIconClass: "location_on",
                navigation: true,
              },
            ],
          },
          {
            name: "Offline Attribution Libraries",
            listPer: "libraries_lsnav",
            group: "offline_libraries",
            entity: "coupon_code",
            navLink: "/coupon-code",
            faIconClass: null,
            matIconClass: "library_books",
            navigation: true,
            children: [
              {
                name: "Coupon Codes",
                listPer: "coupon_code",
                isPlatformEntity: false,
                agAdvLstPrm: null,
                advLstPrm: null,
                group: "coupon_code",
                navLink: "/coupon-code",
                entity: "coupon_code",
                faIconClass: null,
                matIconClass: "code",
                navigation: true,
              },
              {
                name: "Stores",
                listPer: "store",
                isPlatformEntity: false,
                agAdvLstPrm: null,
                advLstPrm: null,
                group: "store",
                navLink: "/store",
                entity: "store",
                faIconClass: null,
                matIconClass: "store",
                navigation: true,
              },
            ],
          },
          {
            name: "Analytics",
            // viewPer: "basic_analytics", uncomment once we support analytics.
            viewPer: "xxx_basic_analytics_xxx",
            entity: "analytics",
            group: "analytics",
            navLink: "/analytics/standard-analytics",
            faIconClass: null,
            matIconClass: "pie_chart",
            adspRegion: null,
            children: [
              {
                name: "Standard",
                viewPer: "basic_analytics",
                entity: "analytics",
                group: "standard_analytics",
                navLink: "/analytics/standard-analytics",
                faIconClass: null,
                matIconClass: "bar_chart",
                adspRegion: null,
              },
              {
                name: "Advanced",
                entity: "analytics",
                viewPer: "need_to_permissions_later_qqq_111_000",
                group: "advanced_analytics",
                navLink: "/analytics/advanced-analytics",
                faIconClass: null,
                matIconClass: "multiline_chart",
                adspRegion: null,
              },
            ],
          },
          {
            name: "Reports",
            listPer: "report",
            group: "reports",
            entity: "reports",
            navLink: "/report/create",
            faIconClass: "fas fa-chart-line me-4",
            matIconClass: null,
            adspRegion: null,
            children: [
              {
                name: "Generate Reports",
                listPer: "report",
                group: "generate_report",
                navLink: "/report/create",
                faIconClass: null,
                matIconClass: "insert_chart_outlined",
                adspRegion: null,
              },
              {
                name: "Manage Reports",
                listPer: "report",
                group: "manage_report",
                navLink: "/report",
                faIconClass: null,
                matIconClass: "table_chart",
                adspRegion: null,
              },
              {
                name: "View Reports",
                listPer: "report",
                group: "view_report",
                viewReport: true,
                faIconClass: null,
                matIconClass: "bar_chart",
                adspRegion: null,
              },
            ],
          },
        ],
      },
      {
        name: "US Amazon",
        toolTip:
          "Amazon Audiences, Amazon Inventory including Prime Video in the US",
        dspType: "adsp_us",
        listPer: "campaign_lsnav",
        navLink: "/adsp/insertion-order",
        liteNavLink: "/adsp/campaign",
        reportNavLink: "/adsp/report",
        faIconClass: null,
        matIconClass: null,
        textIcon: "a",
        adspRegion: "US",
        children: [
          {
            name: "Dashboard",
            listPer: "report",
            group: "tdsp_dashboard",
            navLink: "",
            faIconClass: null,
            matIconClass: "dashboard",
            navigation: true,
          },
          {
            name: "Campaigns",
            listPer: "campaign_lsnav",
            group: "adsp_campaigns",
            entity: "insertion_order",
            navLink: "/adsp/insertion-order",
            faIconClass: "fas me-3 fa-bullhorn",
            matIconClass: null,
            navigation: true,
            children: [
              {
                name: "Insertion Orders",
                listPer: "campaign_lsnav",
                group: "adsp_io",
                navLink: "/adsp/insertion-order",
                faIconClass: "fas fa-money-check ",
                matIconClass: null,
                navigation: true,
              },
              {
                name: "Line Items",
                listPer: "line_item",
                group: "adsp_li",
                navLink: "/adsp/campaign",
                faIconClass: "fas fa-bullhorn",
                matIconClass: null,
                navigation: true,
              },
            ],
          },
          {
            name: "Libraries",
            listPer: "libraries_lsnav",
            group: "adsp_libraries",
            entity: "inventory_list",
            navLink: "/adsp/inventory",
            navLinkTwo: "/segment-pixel",
            faIconClass: null,
            matIconClass: "library_books",
            navigation: true,
            children: [
              {
                name: "Inventory Lists",
                isPlatformEntity: true,
                agAdvLstPrm: "agadv_inventory_list",
                advLstPrm: "advertiser_inventory_list",
                entity: "inventory_list",
                group: "adsp_il",
                navLink: "/adsp/inventory",
                faIconClass: null,
                matIconClass: "list",
                navigation: true,
              },
              {
                name: "Creatives",
                listPer: "creative",
                isPlatformEntity: false,
                agAdvLstPrm: null,
                advLstPrm: null,
                group: "adsp_crtv",
                navLink: "/adsp/creative",
                entity: null,
                faIconClass: "fas fa-ad ms-1",
                matIconClass: null,
                navigation: true,
              },
              {
                name: "Audiences",
                isPlatformEntity: true,
                agAdvLstPrm: "agadv_segment",
                advLstPrm: "advertiser_segment",
                group: "adsp_seg",
                navLink: "/adsp/segment-pixel",
                entity: null,
                faIconClass: null,
                matIconClass: "my_location",
                navigation: true,
              },
              {
                name: "Events",
                listPer: "pixel",
                isPlatformEntity: false,
                agAdvLstPrm: null,
                advLstPrm: null,
                group: "adsp_event",
                navLink: "/adsp/event",
                entity: null,
                faIconClass: null,
                matIconClass: "event",
                navigation: true,
              },
              {
                name: "Conversion Trackers",
                listPer: "pixel",
                isPlatformEntity: false,
                agAdvLstPrm: null,
                advLstPrm: null,
                group: "adsp_conversion_tracker",
                navLink: "/adsp/conversion-tracker",
                entity: null,
                faIconClass: null,
                matIconClass: "track_changes",
                navigation: true,
              },
              {
                name: "Deals",
                listPer: "deal_client_view",
                isPlatformEntity: true,
                advLstPrm: "advertiser_user",
                agAdvLstPrm: null,
                group: "adsp_deals",
                navLink: "/adsp/deals",
                entity: "deals",
                faIconClass: null,
                matIconClass: "local_offer",
                navigation: true,
              },
            ],
          },
          {
            name: "Reports",
            listPer: "report",
            group: "adsp_reports",
            entity: "reports",
            navLink: "/adsp/report/create",
            faIconClass: "fas fa-chart-line me-4",
            matIconClass: null,
            adspRegion: "US",
            children: [
              {
                name: "Generate Reports",
                listPer: "report",
                group: "adsp_generate_report",
                navLink: "/adsp/report/create",
                faIconClass: null,
                matIconClass: "insert_chart_outlined",
                adspRegion: "US",
              },
              {
                name: "Manage Reports",
                listPer: "report",
                group: "adsp_manage_report",
                navLink: "/adsp/report",
                faIconClass: null,
                matIconClass: "table_chart",
                adspRegion: "US",
              },
              {
                name: "View Reports",
                listPer: "report",
                group: "adsp_view_report",
                viewReport: true,
                faIconClass: null,
                matIconClass: "bar_chart",
                adspRegion: "US",
              },
            ],
          },
        ],
      },
      {
        name: "EU Amazon",
        toolTip:
          "Amazon Audiences, Amazon Inventory including Prime Video in the EU",
        dspType: "adsp_eu",
        listPer: "campaign_lsnav",
        navLink: "/adsp/insertion-order",
        liteNavLink: "/adsp/campaign",
        reportNavLink: "/adsp/report",
        faIconClass: null,
        textIcon: "a",
        matIconClass: null,
        adspRegion: "EU",
        children: [
          {
            name: "Dashboard",
            listPer: "report",
            group: "tdsp_dashboard",
            navLink: "",
            faIconClass: null,
            matIconClass: "dashboard",
            navigation: true,
          },
          {
            name: "Campaigns",
            listPer: "campaign_lsnav",
            group: "adsp_campaigns",
            entity: "insertion_order",
            navLink: "/adsp/insertion-order",
            faIconClass: "fas me-3 fa-bullhorn",
            matIconClass: null,
            navigation: true,
            children: [
              {
                name: "Insertion Orders",
                listPer: "campaign_lsnav",
                group: "adsp_io",
                navLink: "/adsp/insertion-order",
                faIconClass: "fas fa-money-check",
                matIconClass: null,
                navigation: true,
              },
              {
                name: "Line Items",
                listPer: "line_item",
                group: "adsp_li",
                navLink: "/adsp/campaign",
                faIconClass: "fas fa-bullhorn",
                matIconClass: null,
                navigation: true,
              },
            ],
          },
          {
            name: "Libraries",
            listPer: "libraries_lsnav",
            group: "adsp_libraries",
            entity: "inventory_list",
            navLink: "/adsp/inventory",
            navLinkTwo: "/segment-pixel",
            faIconClass: null,
            matIconClass: "library_books",
            navigation: true,
            children: [
              {
                name: "Inventory Lists",
                isPlatformEntity: true,
                agAdvLstPrm: "agadv_inventory_list",
                advLstPrm: "advertiser_inventory_list",
                entity: "inventory_list",
                group: "adsp_il",
                navLink: "/adsp/inventory",
                faIconClass: null,
                matIconClass: "list",
                navigation: true,
              },
              {
                name: "Creatives",
                listPer: "creative",
                isPlatformEntity: false,
                agAdvLstPrm: null,
                advLstPrm: null,
                group: "adsp_crtv",
                navLink: "/adsp/creative",
                entity: null,
                faIconClass: "fas fa-ad ms-1",
                matIconClass: null,
                navigation: true,
              },
              {
                name: "Audiences",
                isPlatformEntity: true,
                agAdvLstPrm: "agadv_segment",
                advLstPrm: "advertiser_segment",
                group: "adsp_seg",
                navLink: "/adsp/segment-pixel",
                entity: null,
                faIconClass: null,
                matIconClass: "my_location",
                navigation: true,
              },
              {
                name: "Events",
                listPer: "pixel",
                isPlatformEntity: false,
                agAdvLstPrm: null,
                advLstPrm: null,
                group: "adsp_event",
                navLink: "/adsp/event",
                entity: null,
                faIconClass: null,
                matIconClass: "event",
                navigation: true,
              },
              {
                name: "Conversion Trackers",
                listPer: "pixel",
                isPlatformEntity: false,
                agAdvLstPrm: null,
                advLstPrm: null,
                group: "adsp_conversion_tracker",
                navLink: "/adsp/conversion-tracker",
                entity: null,
                faIconClass: null,
                matIconClass: "track_changes",
                navigation: true,
              },
              {
                name: "Deals",
                listPer: "deal_client_view",
                isPlatformEntity: true,
                advLstPrm: "advertiser_user",
                agAdvLstPrm: null,
                group: "adsp_deals",
                navLink: "/adsp/deals",
                entity: "deals",
                faIconClass: null,
                matIconClass: "local_offer",
                navigation: true,
              },
            ],
          },
          {
            name: "Reports",
            listPer: "report",
            entity: "reports",
            group: "adsp_reports",
            navLink: "/adsp/report/create",
            faIconClass: "fas fa-chart-line me-4",
            matIconClass: null,
            adspRegion: "US",
            children: [
              {
                name: "Generate Reports",
                listPer: "report",
                group: "adsp_generate_report",
                navLink: "/adsp/report/create",
                faIconClass: null,
                matIconClass: "insert_chart_outlined",
                adspRegion: "EU",
              },
              {
                name: "Manage Reports",
                listPer: "report",
                group: "adsp_manage_report",
                navLink: "/adsp/report",
                faIconClass: null,
                matIconClass: "table_chart",
                adspRegion: "EU",
              },
              {
                name: "View Reports",
                listPer: "report",
                group: "adsp_view_report",
                viewReport: true,
                faIconClass: null,
                matIconClass: "bar_chart",
                adspRegion: "EU",
              },
            ],
          },
        ],
      },
      {
        name: "Restricted Inventory",
        // toolTip: "Crypto, Political Categories",
        toolTip:
          "Restricted Global Audiences, Restricted Inventory (Including CTV and OTT)",
        dspType: "bdsp",
        listPer: "campaign_lsnav",
        navLink: "/bdsp/insertion-order",
        liteNavLink: "/bdsp/campaign",
        reportNavLink: "/bdsp/report",
        faIconClass: "fas fa-user-shield me-3",
        matIconClass: null,
        adspRegion: null,
        children: [
          {
            name: "Dashboard",
            listPer: "report",
            group: "tdsp_dashboard",
            navLink: "",
            faIconClass: null,
            matIconClass: "dashboard",
            navigation: true,
          },
          {
            name: "Campaigns",
            listPer: "campaign_lsnav",
            group: "bdsp_campaigns",
            entity: "insertion_order",
            navLink: "/bdsp/insertion-order",
            faIconClass: "fas me-3 fa-bullhorn",
            matIconClass: null,
            navigation: true,
            children: [
              {
                name: "Insertion Orders",
                listPer: "campaign_lsnav",
                group: "bdsp_io",
                navLink: "/bdsp/insertion-order",
                faIconClass: "fas fa-money-check",
                matIconClass: null,
                navigation: true,
              },
              {
                name: "Line Items",
                listPer: "line_item",
                group: "bdsp_li",
                navLink: "/bdsp/campaign",
                faIconClass: "fas fa-bullhorn",
                matIconClass: null,
                navigation: true,
              },
            ],
          },
          {
            name: "Libraries",
            listPer: "libraries_lsnav",
            group: "bdsp_libraries",
            entity: "inventory_list",
            navLink: "/bdsp/custom-list",
            navLinkTwo: "/segment-pixel",
            faIconClass: null,
            matIconClass: "library_books",
            navigation: true,
            children: [
              {
                name: "Custom Lists",
                isPlatformEntity: true,
                agAdvLstPrm: "agadv_inventory_list",
                advLstPrm: "advertiser_inventory_list",
                entity: "inventory_list",
                group: "bdsp_cl",
                navLink: "/bdsp/custom-list",
                faIconClass: null,
                matIconClass: "list",
                navigation: true,
              },
              {
                name: "Creatives",
                listPer: "creative",
                isPlatformEntity: false,
                agAdvLstPrm: null,
                advLstPrm: null,
                group: "bdsp_crtv",
                navLink: "/bdsp/creative",
                entity: null,
                faIconClass: "fas fa-ad ms-1",
                matIconClass: null,
                navigation: true,
              },
              {
                name: "Segments",
                isPlatformEntity: true,
                agAdvLstPrm: "agadv_segment",
                advLstPrm: "advertiser_segment",
                group: "bdsp_seg",
                navLink: "/bdsp/segment-pixel",
                entity: null,
                faIconClass: null,
                matIconClass: "my_location",
                navigation: true,
              },
              {
                name: "Deals",
                listPer: "deal_client_view",
                isPlatformEntity: true,
                advLstPrm: "advertiser_user",
                agAdvLstPrm: null,
                group: "bdsp_deals",
                navLink: "/bdsp/deals",
                entity: "deals",
                faIconClass: null,
                matIconClass: "local_offer",
                navigation: true,
              },
              {
                name: "Events",
                listPer: "pixel",
                isPlatformEntity: false,
                agAdvLstPrm: null,
                advLstPrm: null,
                group: "bdsp_event",
                navLink: "/bdsp/event",
                entity: null,
                faIconClass: null,
                matIconClass: "event",
                navigation: true,
              },
              {
                name: "Delivery Modifiers",
                listPer: "delivery_modifier",
                isPlatformEntity: false,
                agAdvLstPrm: null,
                advLstPrm: null,
                group: "bdsp_dlv_mod",
                navLink: "/bdsp/delivery-modifier",
                entity: null,
                faIconClass: null,
                matIconClass: "settings",
                navigation: true,
              },
            ],
          },
          {
            name: "Reports",
            listPer: "report",
            entity: "reports",
            group: "bdsp_reports",
            navLink: "/bdsp/report/create",
            faIconClass: "fas fa-chart-line me-4",
            matIconClass: null,
            children: [
              {
                name: "Generate Reports",
                listPer: "report",
                group: "bdsp_generate_report",
                navLink: "/bdsp/report/create",
                faIconClass: null,
                matIconClass: "insert_chart_outlined",
              },
              {
                name: "Manage Reports",
                listPer: "report",
                group: "bdsp_manage_report",
                navLink: "/bdsp/report",
                faIconClass: null,
                matIconClass: "table_chart",
              },
              {
                name: "View Reports",
                listPer: "report",
                group: "bdsp_view_report",
                viewReport: true,
                faIconClass: null,
                matIconClass: "bar_chart",
              },
            ],
          },
        ],
      },
      {
        name: "Hyperlocal",
        toolTip:
          "Global Audiences, Global Inventory (Including CTV and OTT) and Netflix Premium",
        dspType: "tdsp_hyperlocal",
        listPer: "campaign_lsnav",
        navLink: "/tdsp-hyperlocal/insertion-order",
        liteNavLink: "/tdsp-hyperlocal/campaign",
        reportNavLink: "/tdsp-hyperlocal/report",
        faIconClass: "fas fa-globe me-3",
        matIconClass: null,
        children: [
          {
            name: "Dashboard",
            listPer: "report",
            group: "tdsp_dashboard",
            navLink: "",
            faIconClass: null,
            matIconClass: "dashboard",
            navigation: true,
          },
          {
            name: "Campaigns",
            listPer: "campaign_lsnav",
            group: "tdsp_campaigns",
            entity: "insertion_order",
            navLink: "/tdsp-hyperlocal/insertion-order",
            faIconClass: "fas me-3 fa-bullhorn",
            matIconClass: null,
            navigation: true,
            children: [
              {
                name: "Insertion Orders",
                listPer: "campaign_lsnav",
                group: "tdsp_io",
                navLink: "/tdsp-hyperlocal/insertion-order",
                faIconClass: "fas fa-money-check",
                matIconClass: null,
                navigation: true,
              },
              {
                name: "Line Items",
                listPer: "line_item",
                group: "tdsp_li",
                navLink: "/tdsp-hyperlocal/campaign",
                faIconClass: "fas fa-bullhorn",
                matIconClass: null,
                navigation: true,
              },
            ],
          },
          // {
          //   name: "Media Plan",
          //   listPer: "forecasting_plan",
          //   group: "tdsp_forecasting_plan",
          //   navLink: "/tdsp-hyperlocal/media-plan",
          //   faIconClass: "fas fa-money-check me-3",
          //   matIconClass: null,
          //   navigation: true,
          //   entity: "media_plan",
          //   navLinkTwo: "/tdsp-hyperlocal/media-plan",
          //   children: [
          //     {
          //       name: "Media Plan",
          //       listPer: "forecasting_plan",
          //       group: "tdsp_media_plan",
          //       navLink: "/tdsp-hyperlocal/media-plan",
          //       faIconClass: "fas fa-money-check",
          //       matIconClass: null,
          //       navigation: true,
          //     },
          //     {
          //       name: "View Media Plan Forecast",
          //       listPer: "forecasting_plan",
          //       group: "tdsp_view_media_plan",
          //       faIconClass: "fas fa-money-check",
          //       matIconClass: null,
          //       navigation: true,
          //     }
          //   ],
          // },
          {
            name: "Libraries",
            listPer: "libraries_lsnav",
            group: "tdsp_libraries",
            entity: "inventory_list",
            navLink: "/tdsp-hyperlocal/creative",
            navLinkTwo: "/tdsp-hyperlocal/creative",
            faIconClass: null,
            matIconClass: "library_books",
            navigation: true,
            children: [
              {
                name: "Creatives",
                listPer: "creative",
                isPlatformEntity: false,
                agAdvLstPrm: null,
                advLstPrm: null,
                group: "tdsp_crtv",
                navLink: "/tdsp-hyperlocal/creative",
                entity: null,
                faIconClass: "fas fa-ad ms-1",
                matIconClass: null,
                navigation: true,
              },
              {
                name: "Conversion Pixels",
                listPer: "pixel",
                isPlatformEntity: false,
                agAdvLstPrm: null,
                advLstPrm: null,
                group: "tdsp_pixel",
                navLink: "/tdsp-hyperlocal/conversion-pixel",
                entity: null,
                faIconClass: null,
                matIconClass: "track_changes",
                navigation: true,
              },
              {
                name: "Custom Locations",
                isPlatformEntity: true,
                agAdvLstPrm: "agadv_cll",
                advLstPrm: "advertiser_cll",
                entity: "custom_location",
                group: "custom_locations",
                navLink: "/tdsp-hyperlocal/custom-location",
                faIconClass: null,
                matIconClass: "location_on",
                navigation: true,
              },
              {
                name: "Deals",
                listPer: "deal_client_view",
                isPlatformEntity: true,
                advLstPrm: "advertiser_user",
                agAdvLstPrm: null,
                group: "tdsp_deals",
                navLink: "/tdsp-hyperlocal/deals",
                entity: "deals",
                faIconClass: null,
                matIconClass: "local_offer",
                navigation: true,
              },
              {
                name: "Inventory Lists",
                listPer: "platform_inventory_list",
                isPlatformEntity: false,
                agAdvLstPrm: null,
                advLstPrm: null,
                entity: "null",
                group: "tdsp_inventory_list",
                navLink: "/tdsp-hyperlocal/inventory-list",
                faIconClass: null,
                matIconClass: "list",
                navigation: true,
              },
              {
                name: "Content Category Lists",
                listPer: "platform_inventory_list",
                isPlatformEntity: false,
                agAdvLstPrm: null,
                advLstPrm: null,
                entity: "null",
                group: "tdsp_inventory_category",
                navLink: "/tdsp-hyperlocal/content-category",
                faIconClass: null,
                matIconClass: "tv_off",
                navigation: true,
              },
              {
                name: "Contextual Keywords",
                listPer: "libraries_lsnav",
                isPlatformEntity: true,
                agAdvLstPrm: "agadv_inventory_list",
                advLstPrm: "advertiser_inventory_list",
                entity: "tdsp_contextual_keyword",
                group: "tdsp_contextual_keyword",
                navLink: "/tdsp-hyperlocal/contextual-keywords",
                faIconClass: null,
                matIconClass: "text_snippet",
                navigation: true,
              },
            ],
          },
          {
            name: "Data Hub",
            listPer: "libraries_lsnav",
            group: "data_hub",
            entity: "segment",
            navLink: "/tdsp-hyperlocal/segments",
            faIconClass: null,
            matIconClass: "device_hub",
            navigation: true,
            children: [
              {
                name: "Data Collection",
                isPlatformEntity: true,
                agAdvLstPrm: "agadv_segment",
                advLstPrm: "advertiser_segment",
                group: "tdsp_seg",
                navLink: "/tdsp-hyperlocal/segments",
                entity: null,
                faIconClass: null,
                matIconClass: "my_location",
                navigation: true,
              },
              {
                name: "Seeds",
                listPer: "seed",
                isPlatformEntity: false,
                agAdvLstPrm: null,
                advLstPrm: null,
                entity: "null",
                group: "seed",
                navLink: "/tdsp-hyperlocal/seed",
                faIconClass: null,
                matIconClass: "spa",
                navigation: true,
              },
              {
                name: "Audience Builder",
                listPer: "creative",
                isPlatformEntity: false,
                agAdvLstPrm: null,
                advLstPrm: null,
                entity: "null",
                group: "audience_builder",
                navLink: "/tdsp-hyperlocal/audience-builder",
                faIconClass: null,
                matIconClass: "group",
                navigation: true,
              },
            ],
          },
          {
            name: "Reports",
            listPer: "report",
            entity: "reports",
            group: "tdsp_reports",
            navLink: "/tdsp-hyperlocal/report/create",
            faIconClass: "fas fa-chart-line me-4",
            matIconClass: null,
            children: [
              {
                name: "Generate Reports",
                listPer: "report",
                group: "tdsp_generate_report",
                navLink: "/tdsp-hyperlocal/report/create",
                faIconClass: null,
                matIconClass: "insert_chart_outlined",
              },
              {
                name: "Manage Reports",
                listPer: "report",
                group: "tdsp_manage_report",
                navLink: "/tdsp-hyperlocal/report",
                faIconClass: null,
                matIconClass: "table_chart",
              },
              {
                name: "View Reports",
                listPer: "report",
                group: "tdsp_view_report",
                viewReport: true,
                faIconClass: null,
                matIconClass: "bar_chart",
              },
            ],
          },
        ],
      },

      {
        name: "DCO",
        toolTip: "Dynamic creative based on Product Feed and Rules",
        dspType: "dco",
        listPer: "campaign_lsnav",
        navLink: "/dco/segments",
        faIconClass: null,
        matIconClass: "ads_click",
        children: [
          {
            name: "Segments",
            listPer: "campaign_lsnav",
            group: "dco_segments",
            entity: "segments",
            navLink: "/dco/segments",
            faIconClass: null,
            matIconClass: "my_location",
            navigation: true,
            children: null,
          },
          {
            name: "Product Feed",
            listPer: "campaign_lsnav",
            group: "dco_product_feed",
            entity: "product_feed",
            navLink: "/dco/product-feed",
            faIconClass: "fa fa-product-hunt me-3",
            matIconClass: null,
            navigation: true,
            children: null,
          },
          {
            name: "Creative Library",
            listPer: "campaign_lsnav",
            group: "dco_libraries",
            entity: "dco_library",
            navLink: "/dco/library",
            faIconClass: "fas fa-file-image me-3",
            matIconClass: null,
            navigation: true,
            children: null,
          },
          {
            name: "Rules",
            listPer: "campaign_lsnav",
            entity: "rules",
            group: "dco_rules",
            navLink: "/dco/rules",
            faIconClass: null,
            matIconClass: "menu_book",
            children: null,
          },
          {
            name: "Creative Packaging",
            listPer: "campaign_lsnav",
            entity: "packaging",
            group: "dco_creative_packaging",
            navLink: "/dco/creative-packaging",
            faIconClass: null,
            matIconClass: "dynamic_feed",
            children: null,
          },
        ],
      },
    ],
  },
  {
    name: "CDP",
    dspType: "nonDSP",
    listPer: "advertiser_user",
    entity: "cdp",
    group: "cdp",
    navLink: "",
    faIconClass: "fas fa-users me-3",
    matIconClass: null,
  },
  {
    name: "Users",
    dspType: "nonDSP",
    listPer: "advertiser_user",
    entity: "users",
    group: "users",
    navLink: "/user",
    faIconClass: "fas fa-users me-3",
    matIconClass: null,
  },
  {
    name: "My Accounts",
    dspType: "nonDSP",
    viewPer: "account_statement",
    group: "account_statement",
    navLink: "/account-statement",
    entity: "account_statement",
    faIconClass: "fas fa-wallet me-3",
    matIconClass: null,
  },
];
